/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoFiltersController {
    /** @ngInject */
    constructor($log, $rootScope) {
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.savedFilterKeys = ['model.domain.domain', 'model.site.site', 'model.equipment.equipment'];
    }

    $onInit() {
        if (!this.$rootScope.savedFilters) {
            this.$rootScope.savedFilters = new Object();
        }
    }

    loadSavedFilters() {
        const savedFilters = Object.values(this.$rootScope.savedFilters);
        if (savedFilters) {
           this.model = this.model.map(modelFilter => {
               let filter = null;
               savedFilters.forEach(savedFilter => {
                   if (modelFilter.placeholderKey === savedFilter.placeholderKey) {
                       filter = savedFilter;
                   }
               });
               if (filter && modelFilter.value === undefined) {
                   modelFilter.value = filter.value;
               }
               return modelFilter;
            });
            this.onApply();
        }
    }

    onSave() {
        this.model.filter(filter => (this.savedFilterKeys.indexOf(filter.placeholderKey) > -1))
            .map(filter => this.$rootScope.savedFilters[filter.placeholderKey] = filter);
        this.onApply();
    }
}

export const gmaoFiltersComponent = {
    template: require('./gmao-filters.html'),
    controller: GmaoFiltersController,
    bindings: {
        model: '=',
        onApply: '&'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoFilters.js